import { createMarkdownChipNode } from './createMarkdownChipNode';

/**
 * markdown-name：报告名称输入 chip，失焦解析展开成 markdown-module。
 * chip 自身 contentEditable（对齐 V1 markdown-name/render.ts），实现见 createMarkdownChipNode.tsx。
 */
export const MarkdownNameNode = createMarkdownChipNode(
  {
    chipClass: 'rte-markdown-name',
    errorClass: 'rte-markdown-name-error',
    dataType: 'markdown-name',
    defaultPlaceholder: '输入名称',
  },
  'MarkdownNameNode',
);
